import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { useNavigate, useParams } from 'react-router-dom';

const ViewCustomer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const response = await api.get(`/customers/${id}`);
        setCustomer(response.data);
      } catch (err) {
        console.error('Error fetching customer:', err);
        setError('Failed to load customer details.');
      } finally {
        setLoading(false);
      }
    };
    fetchCustomer();
  }, [id]);

  if (loading) return <div className="container mt-4"><p>Loading customer details...</p></div>;
  if (error)   return <div className="container mt-4"><p className="text-danger">{error}</p></div>;
  if (!customer) return null;

  const fields = [
    { label: 'Full Name',          value: customer.full_name },
    { label: 'Email',              value: customer.email },
    { label: 'Phone Number',       value: customer.phone_number },
    { label: 'Customer Type',      value: customer.customer_type },
    { label: 'Branch',             value: customer.branch_name },
    { label: 'Relationship Staff', value: customer.relationship_staff },
    { label: 'Nationality',        value: customer.nationality },
    { label: 'Residence Country',  value: customer.residence_country },
    { label: 'Address',            value: customer.full_address },
    { label: 'Passport Number',    value: customer.passport_number },
    { label: 'TRN Number',         value: customer.trn_number },
    { label: 'Opening Balance',    value: customer.opening_balance !== undefined ? `${customer.opening_balance}` : undefined },
  ];

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>📋 Customer Details</h2>
        <div className="d-flex gap-2">
          <button
            className="btn btn-warning"
            onClick={() => navigate(`/dashboard/customers/edit/${id}`)}
          >
            ✏️ Edit Customer
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate('/dashboard/customers/list')}
          >
            ← Back to List
          </button>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <table className="table table-borderless mb-0">
            <tbody>
              {fields.map((f, i) =>
                f.value ? (
                  <tr key={i}>
                    <th style={{ width: '200px', color: '#555' }}>{f.label}</th>
                    <td>{f.value}</td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewCustomer;
